import React, { useState } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { Formik, Form } from "formik";

import Button from "../../../../shared/components/Buttons/Button";
import SimpleInputTextField from "../../../../shared/components/inputTextField/SimpleInputTextField";
import InputNumberField from "../../../../shared/components/inputNumberField/InputNumberField";
import {
  buttonNameConstants,
  buttonTypeConstants,
  modalConstants,
} from "../../../../constants";
import { parseToNumber } from "../../../../shared/utility";

const ConfirmationModalWithValue = (props) => {
  const {
    size = "md",
    title = "Confirmation",
    isConfirmationModal,
    isNoButton = true,
    handleNoButtonClick,
    noButtonText = buttonNameConstants.NO,
    yesButtonText = buttonNameConstants.YES,
    handleYesButtonClick,
    toggleConfirmationModal,
    showInput = false,
    inputLabel = "",
    inputPlaceholder = "",
    isLoading = false,
    type = modalConstants.DEFAULT,
    fieldName,
    validateSchema,
  } = props;

  const [inputValue, setInputValue] = useState("");
  const [showError, setShowError] = useState(false);

  const onYesClick = () => {
    if (!inputValue.trim()) {
      setShowError(true);
      return;
    }
    handleYesButtonClick(inputValue);
    setInputValue("");
    setShowError(false);
  };
  const isNumberInput = type === modalConstants.NUMBER_INPUT_FIELD;
  const shouldShowInput = showInput || isNumberInput;
  const shouldShowFooterButtons = !isNumberInput;
  return (
    <Modal
      size={size}
      centered
      backdrop="static"
      show={isConfirmationModal}
      onHide={toggleConfirmationModal}
      className="nested-modal-z-index"
      backdropClassName="nested-modal-z-index"
    >
      <Modal.Header className="position-relative">
        <Modal.Title className="w-100 text-center">{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="m-0">
          {shouldShowInput &&
            (isNumberInput ? ( // If it is number input, use Formik
              <Col md={12} className="mb-4">
                {/* Formik Logic for Number Input */}
                <Formik
                  initialValues={{ [fieldName]: 1 }}
                  onSubmit={(values) => {
                    handleYesButtonClick({
                      ...values,
                      [fieldName]: parseToNumber(values[fieldName]),
                    });
                    toggleConfirmationModal();
                  }}
                  validate={validateSchema}
                >
                  {({ values }) => (
                    <Form>
                      <InputNumberField
                        label={inputLabel || title}
                        name={fieldName}
                        value={values[fieldName]}
                        placeHolder="0"
                        className="w-100"
                        type="number"
                      />
                      {/* As we are using Formik, So, we are using yes no button here to submit form */}
                      <div className="d-flex justify-content-center gap-2 w-100 mt-4">
                        <Button
                          type="button"
                          label={noButtonText}
                          handleClick={toggleConfirmationModal}
                          buttonType={buttonTypeConstants.GHOST_BUTTON}
                          className="w-100"
                        />
                        <Button
                          type="submit"
                          className="w-100"
                          label={yesButtonText}
                          isLoading={isLoading}
                        />
                      </div>
                    </Form>
                  )}
                </Formik>
              </Col>
            ) : (
              <Col md={12} className="mb-4 d-flex align-items-start gap-2">
                <span className="stolen-card-text fs-4 input-label-normal mt-2">
                  {`${inputLabel}:`}
                </span>

                <div className="d-flex flex-column w-100">
                  <SimpleInputTextField
                    value={inputValue}
                    placeHolder={inputPlaceholder || "Enter nickname"}
                    onChange={(e) => {
                      setInputValue(e.target.value);
                      if (showError) setShowError(false);
                    }}
                    wrapperClassName="input-30em"
                  />
                  {/* Always reserve space for error */}
                  <div
                    className="text-red mt-1"
                    style={{ minHeight: "1.25em" }}
                  >
                    {showError ? `${inputLabel} can't be empty` : ""}
                  </div>
                </div>
              </Col>
            ))}

          {shouldShowFooterButtons && (
            <Col md={12} className="d-flex gap-2">
              {isNoButton && (
                <Button
                  type="button"
                  label={noButtonText}
                  buttonType={buttonTypeConstants.GHOST_BUTTON}
                  className="w-100"
                  handleClick={handleNoButtonClick}
                  isDisabled={isLoading}
                />
              )}
              <Button
                type="button"
                label={yesButtonText}
                className="w-100"
                handleClick={onYesClick}
                disabled={showInput && !inputValue.trim()}
                isDisabled={isLoading}
                isLoading={isLoading}
              />
            </Col>
          )}
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModalWithValue;
